module.exports = __webpack_public_path__ + "img/cv.fb3b4449.svg";